<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Información de la opcón de envió</h1>
		<div class="information" v-if="option">
			<p class="information__text"><strong class="information__text--strong">Nombre: </strong>{{option.name }}</p>

			<p v-if="option.type_name" class="information__text"><strong class="information__text--strong">Tipo: </strong><span v-text="option.type_name"></span></p>

			<p v-if="option.min_mxn" class="information__text">
				<strong class="information__text--strong">Monto mínimo en pesos: </strong><span>{{ option.min_mxn | price }}</span>
			</p>

			<p v-if="option.min_usd" class="information__text">
				<strong class="information__text--strong">Monto mínimo en dólares: </strong><span>{{ option.min_usd | price({ currency: 'USD', lang: 'en-US' }) }}</span>
			</p>

			<p v-if="option.country_es" class="information__text"><strong class="information__text--strong">País: </strong><span v-text="option.country_es"></span></p>

			<p v-if="option.country_id == mexicoId" class="information__text"><strong class="information__text--strong">Estado: </strong><span v-text="option.state"></span></p>

			<p v-if="option.status_id" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{ option.status_id | optionStatus}}</p>

			<p v-if="option.title_es" class="information__text"><strong class="information__text--strong">Título Español: </strong>{{ option.title_es }}</p>

			<p v-if="option.description_es" class="information__text"><strong class="information__text--strong">Descripción Español: </strong>{{ option.description_es }}</p>

			<p v-if="option.title_en" class="information__text"><strong class="information__text--strong">Título Inglés: </strong>{{ option.title_en }}</p>

			<p v-if="option.description_en" class="information__text"><strong class="information__text--strong">Descripción Inglés: </strong>{{ option.description_en }}</p>
		</div>
	</div>
</template>

<script>
import optionMixins from './mixins'
	export default {
		props: {
			option: {
				type: Object
			}
		},
		mixins: [optionMixins],
		data: function () {
			return {
				mexicoId: 144
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/free_shipping/view.vue